import { render, staticRenderFns } from "./label.vue?vue&type=template&id=62f4dae2&scoped=true&"
import script from "./label.vue?vue&type=script&lang=js&"
export * from "./label.vue?vue&type=script&lang=js&"
import style0 from "./label.vue?vue&type=style&index=0&id=62f4dae2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f4dae2",
  null
  
)

export default component.exports